<!-- 
====USE:====
--TEMPLATE--
<SecurityRoleSelect
  :base_id="objItem.id_data"
  :role_list="objItemData.role_data"
  @roleIdList="updateRole"
></SecurityRoleSelect>

--COMPONENT--
import SecurityRoleSelect from "@/modules/security_ds/internal/security_role/SecurityRoleSelect";
components: { SecurityRoleSelect },

--METHOD--
updateRole(payload) {
  this.objItemData.role_data = payload;
}

-->
<template>
  <div>
    <hr />
    <div class="form-row" id="wt-role-component">
      <div id="wt-loading-role-component" v-show="loading">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
      <div class="form-group col-md-12 mb-0">
        <label>Roles</label>
      </div>
      <!-- Roles disponíveis -->
      <div class="form-group col-md-5">
        <!-- Search -->
        <b-input-group>
          <template v-slot:prepend>
            <b-input-group-text style="font-size: 12px; color: grey">
              <i class="fas fa-filter"></i>
            </b-input-group-text>
          </template>
          <b-form-input v-model="keyword" class="form-control" placeholder="Search"></b-form-input>
        </b-input-group>
        <!-- (fim) Search -->

        <select name="role_list" size="6" class="wt-select-card" v-model="selectedRole">
          <option
            v-for="role in keyword?filteredRole:sortRole()"
            :key="role.role_id"
            :value="role.role_id"
          >{{role.role_description}}</option>
          <option v-if="isEmpty(roleList)" disabled>...</option>
        </select>
      </div>
      <!-- (fim) Roles disponíveis -->

      <!-- Controladores -->
      <div class="form-group col-md-2">
        <!-- Add -->
        <b-button
          variant="primary"
          @click="addNewRole(selectedRole)"
          style="width: 100%"
          class="mb-1 role-pre-btn"
        >
          Add
          <span v-show="!responsive">
            <i class="fas fa-arrow-right arrow-role arrow-right"></i>
          </span>
          <span v-show="responsive">
            <i class="fas fa-arrow-down arrow-role arrow-right"></i>
          </span>
        </b-button>
        <!-- Remove -->
        <b-button
          variant="primary"
          @click="removeARole"
          style="width: 100%"
          class="mb-1 role-pre-btn"
        >
          <span v-show="!responsive">
            <i class="fas fa-arrow-left arrow-role arrow-left"></i>
          </span>
          <span v-show="responsive">
            <i class="fas fa-arrow-up arrow-role arrow-left"></i>
          </span> Remove
        </b-button>
        <!-- Remove All -->
        <b-button
          variant="primary"
          @click="removeAllRoles"
          style="width: 100%"
          class="role-pre-btn"
        >
          <span v-show="!responsive">
            <i class="fas fa-arrow-left arrow-role arrow-left"></i>
          </span>
          <span v-show="responsive">
            <i class="fas fa-arrow-up arrow-role arrow-left"></i>
          </span> Remove All
        </b-button>
      </div>
      <!-- (fim) Controladores -->

      <!-- Roles Selecionadas -->
      <div class="form-group col-md-5">
        <select
          name="selected_predecessor_list"
          size="7"
          class="wt-select-card"
          v-model="selectedRoleRemove"
        >
          <option
            v-for="role in roleListSelected"
            :key="role.role_id"
            :value="role.role_id"
          >{{role.role_description}}</option>
          <option v-if="isEmpty(roleListSelected)" disabled>...</option>
        </select>
      </div>
      <!-- (fim) Roles Selecionadas -->
    </div>
  </div>
</template>
<script>
/** RECURSOS DO VUE **/
import { baseApiUrl, baseApiPort } from "@/global";
import axios from "axios";

export default {
  name: "SecurityRoleSelect",
  components: {},
  props: {
    base_id: String,
    role_list: [Object, Array, String]
  },
  data: function() {
    return {
      /* Controls */
      urlServices: "security-ds/api/internal/security-role",
      primary_key: "security_role_id",

      keyword: "",
      responsive: false,
      loading: false,
      receiver: "",

      roleList: [],
      roleListSelected: [],
      selectedRole: "",
      selectedRoleRemove: ""
    };
  },
  computed: {
    filteredRole() {
      return this.roleList.filter(post => {
        return post.role_description
          .toLowerCase()
          .includes(this.keyword.toLowerCase());
      });
    },
    mq() {
      return this.$mq;
    }
  },
  methods: {
    /*-- Carrega a lista de itens disponíveis--*/
    getRoleList() {
      this.clearRoleList();
      let tempRoleList = {};

      const url = `${baseApiUrl}:${baseApiPort}/${this.urlServices}/find-all`;
      axios.post(url).then(res => {
        if (res.data[0][`${this.primary_key}`] != null) {
          tempRoleList = res.data;

          this.loading = true;
          tempRoleList.forEach(e => {
            /* IGNORA ITENS COM END_DT PREENCHIDO */
            if (!e.security_role_data.end_dt) {
              this.roleList.push({
                role_id: e.security_role_id,
                role_description: e.security_role_data.role_description
              });
            if (this.roleList.length == tempRoleList.length - 1) {
              this.$nextTick(() => {
                this.getSelectedRoleList();
              });
            }
          }
          this.loading = false;
        });
      }

        setTimeout(() => {
          this.getSelectedRoleList();
        }, 1000);
      });
    },

    /*-- Carrega objetos já selecionados --*/
    getSelectedRoleList() {
      if (this.role_list) {
        let toArray = this.stringToArray(this.role_list);

        toArray.forEach(e => {
          this.addNewRole(e);
        });

        this.loading = false;
      } else {
        this.loading = false;
      }
    },
    stringToArray(input) {
      if (!Array.isArray(input)) {
        var adapt = String(input).replace("[", "");
        adapt = adapt.replace("]", "");
        adapt = adapt.replace(/'/g, "");
        adapt = adapt.replace(/"/g, "");
        adapt = adapt.split(",");
        return adapt;
      } else {
        return input;
      }
    },

    /**
     * TASKS SELECT BOX - Controla a entrada e saída
     * de roles predecessoras da lista, incluindo o
     * posicionamento em ordem alfabética e conversão
     * JSON>ARRAY e ARRAY>JSON
     */

    /*retorna lista em ordem alfabetica*/
    sortRole() {
      return this.roleList.slice().sort(function(a, b) {
        return a.role_description > b.role_description ? 1 : -1;
      });
    },
    /*Limpa a lista*/
    clearRoleList() {
      this.roleList = [];
      this.roleListSelected = [];
      this.selectedRole = "";
      this.selectedRoleRemove = "";
    },
    /*Remove da esquerda, adiciona na direita*/
    addNewRole(filt) {
      if (filt && !this.isEmpty(this.roleList)) {
        var objFiltered = this.roleList.filter(function(elem) {
          if (elem.role_id == filt) return elem;
        });
        if (!this.isEmpty(objFiltered)) {
          this.roleListSelected.push(objFiltered[0]);
          this.roleList.splice(
            this.roleList.findIndex(r => r.role_id === filt),
            1
          );
          this.selectedRole = "";
          this.updateObjItemDataList();
        }
      }
    },
    /*Remove da direita, adiciona na esquerda*/
    removeARole() {
      if (this.selectedRoleRemove) {
        const filt = this.selectedRoleRemove;
        var objFiltered = this.roleListSelected.filter(function(elem) {
          if (elem.role_id == filt) return elem;
        });
        this.roleList.push(objFiltered[0]);
        this.roleListSelected.splice(
          this.roleListSelected.findIndex(r => r.role_id === filt),
          1
        );
        this.selectedRoleRemove = "";
        this.updateObjItemDataList();
      }
    },
    /*Remove TODAS da direita e adiciona na esquerda*/
    removeAllRoles() {
      this.roleListSelected.forEach(e => this.roleList.push(e));
      this.roleListSelected = [];
      this.updateObjItemDataList();
    },

    /*Emite a lista gerada para o Objeto Pai*/
    updateObjItemDataList() {
      let splitList = [];
      let emitData = null;
      if (!this.isEmpty(this.roleListSelected)) {
        this.roleListSelected.forEach(e => {
          splitList.push(e.role_id);
        });
        emitData = splitList.join(",");
        // emitData: "id, id, id"
        // splitList: ["id","id","id"]
        this.$emit("roleIdList", emitData);
      } else {
        this.$emit("roleIdList", "");
      }
    },
    isEmpty(obj) {
      for (let x in obj) {
        return false;
      }
      return true;
    },
    getSizewindow() {
      if (this.mq == "sm" || this.mq == "xs") {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  },
  watch: {
    mq() {
      this.getSizewindow();
    }
  },
  mounted() {
    this.getRoleList();
    this.getSizewindow();
  }
};
</script>
